import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { withFormik } from 'formik';

import { PaymentForm } from './paymentForm.component';
import { defaultValues, PaymentSchema } from './paymentForm.constants';
import { AuthActions, selectIsSignedIn } from '../../../modules/auth';
import { selectUserData } from '../../../modules/user';
import { BookingActions, selectBookingPaymentStatus } from '../../../modules/booking';

const mapStateToProps = createStructuredSelector({
  isSignedIn: selectIsSignedIn,
  userData: selectUserData,
  paymentStatus: selectBookingPaymentStatus,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPayment: BookingActions.setPayment,
      paymentTokenReceived: BookingActions.paymentTokenReceived,
      requestNextStep: BookingActions.requestNextStep,
      signOut: AuthActions.signOut,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter,
  withFormik({
    mapPropsToValues: ({ userData }) => defaultValues(userData),
    handleSubmit: async (data, { props, ...formik }) => {
      try {
        formik.setSubmitting(true);
        props.requestNextStep(data);
      } catch ({ errors }) {
        formik.setErrors(errors);
      } finally {
        formik.setSubmitting(false);
      }
    },
    validationSchema: () => PaymentSchema,
    validateOnChange: false,
  })
)(PaymentForm);
